@if (control) {
  @if (question.presentation === "SINGLE_LINE") {
    <input
      type="text"
      [id]="question.id"
      [class]="
        'border w-full px-2 py-3 bg-[initial] focus:outline' +
        (customClass ? ' ' + customClass : '')
      "
      [formControl]="control"
      (blur)="onBlur()"
      (focus)="onFocus($event)"
      [title]="title || question.title"
    />
  } @else if (question.presentation === "MULTI_LINE") {
    <div class="textarea-wrapper">
      <textarea
        rows="5"
        onInput="this.parentNode.dataset.value = this.value"
        [id]="question.id"
        [class]="
          'border w-full focus:outline' + (customClass ? ' ' + customClass : '')
        "
        type="text"
        [formControl]="control"
        (blur)="onBlur()"
        (focus)="onFocus($event)"
        [title]="title || question.title"
      ></textarea>
    </div>
  }
  @if (!hideError) {
    <app-open-answer-validation
      [question]="question"
      [control]="control"
    ></app-open-answer-validation>
  }
}
